<template>
  <!-- eslint-disable-next-line prefer-standard-components/no-vuetify-inputs -->
  <v-select
    v-model="modelValue"
    :aria-label="ariaLabelResolved"
    :class="inputClass"
    :data-testid="dataTestid"
    :item-title="itemTitle"
    :item-value="itemValue"
    :items="items"
    :list-props="{ class: 'b-1 bc-very-light-gray' }"
    :placeholder="placeholder"
    base-color="#adadad"
    bg-color="#ffffff"
    density="compact"
    variant="outlined"
    flat
    hide-details
    tracked
  />
</template>

<script setup>
const modelValue = defineModel({
  type: [String, Number, Object],
  default: null,
});

const props = defineProps({
  ariaLabel: {
    type: String,
    default: null,
  },
  dataTestid: {
    type: String,
    default: 'standard-select',
  },
  inputClass: {
    type: String,
    default: 'w-350',
  },
  itemTitle: {
    type: String,
    default: 'name',
  },
  itemValue: {
    type: String,
    default: 'id',
  },
  items: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: '',
  },
});

const ariaLabelResolved = computed(() => props.ariaLabel || props.placeholder || 'Select');
</script>

<style scoped>
/* Match StandardButton min-height (WCAG 2.1 AAA touch target) so toolbar controls align. */
:deep(.v-field) {
  min-height: 3rem !important;
}

:deep(.v-field__field) {
  align-items: center;
}

@media (min-width: 48rem) {
  :deep(.v-field) {
    min-height: 2.75rem !important;
  }
}
</style>
